import React, {FunctionComponent, createContext, useContext, useMemo} from 'react';

interface ContentCardContextProps {
  isVisible: boolean;
}

export const ContentCardContext = createContext<ContentCardContextProps>({
  isVisible: true,
});

interface ContentCardContextProviderProps extends ContentCardContextProps {
  children: any;
}

export const ContentCardContextProvider: FunctionComponent<ContentCardContextProviderProps> = ({
  isVisible = true,
  children,
}: ContentCardContextProviderProps) => {
  const value = useMemo(() => ({isVisible}), [isVisible]);

  return (
    <ContentCardContext.Provider value={value}>
      {children}
    </ContentCardContext.Provider>
  )
};

export const useIsVisible = () => {
  const {isVisible} = useContext(ContentCardContext);
  return isVisible;
};

export default ContentCardContextProvider;
